import type { Namespace, Region, RegionOption } from './types';

export const NAMESPACES: Namespace[] = ['development', 'staging', 'production'];

export const AGENT_STUDIO_URL = {
  development: 'https://studio.dev.poly.ai',
  staging: 'https://studio.staging.poly.ai',
  'us-production': 'https://studio.us.poly.ai',
  'uk-production': 'https://studio.uk.poly.ai',
  'eu-production': 'https://studio.eu.poly.ai',
};

export const REGION_REDIRECT_MAP: {
  [key in Namespace]: { [key in Region]: string };
} = {
  development: {
    australia: AGENT_STUDIO_URL.development,
    canada: AGENT_STUDIO_URL.development,
    ireland: AGENT_STUDIO_URL.development,
    'united-kingdom': AGENT_STUDIO_URL.development,
    'united-states': AGENT_STUDIO_URL.development,
  },
  staging: {
    australia: AGENT_STUDIO_URL.staging,
    canada: AGENT_STUDIO_URL.staging,
    ireland: AGENT_STUDIO_URL.staging,
    'united-kingdom': AGENT_STUDIO_URL.staging,
    'united-states': AGENT_STUDIO_URL.staging,
  },
  production: {
    australia: AGENT_STUDIO_URL['us-production'],
    canada: AGENT_STUDIO_URL['us-production'],
    ireland: AGENT_STUDIO_URL['uk-production'],
    'united-kingdom': AGENT_STUDIO_URL['uk-production'],
    'united-states': AGENT_STUDIO_URL['us-production'],
  },
};

export const REGIONS: RegionOption[] = [
  { label: 'Australia', value: 'australia', icon: '🇦🇺' },
  { label: 'Canada', value: 'canada', icon: '🇨🇦' },
  { label: 'Ireland', value: 'ireland', icon: '🇮🇪' },
  { label: 'United Kingdom', value: 'united-kingdom', icon: '🇬🇧' },
  { label: 'United States', value: 'united-states', icon: '🇺🇸' },
];

export const NEW_INTEGRATION_QUERY_PARAM = 'new_integration';
